import { Injectable } from '@angular/core';
import { BaseProvider } from '../BaseProvider';
import { Router } from '@angular/router';
import { Http } from '@angular/http';

@Injectable()
export class B2CRateMasterService extends BaseProvider {
    constructor(private http: Http, private router: Router) {
        super(http);
    }


    //----- consumerRateRuleSlabCurrencyCodes
    getCurrenciesForSlab(product) {
        return this.makeGetCall('consumerRateRuleSlabCurrencyCodes?product=' + product);
    }

    //----- get all slabs using product
    getSlabByProduct(product) {
        return this.makeGetCall('consumerRateRuleSlabSlabs?product=' + product);
    }

    //----- get all details filter using product slabmin slabmax currencyCode
    getRateRuleBySlab(productType, slabMin, slabMax) {
        let resourceURL = "consumerRateRuleSlabDetails/" + productType + "?" +
            "slabMin=" + slabMin +
            "&slabMax=" + slabMax;
        return this.makeGetCall(resourceURL);
    }

    //----- Create new slabs
    createNewSlab(requestModel) {
        return this.makePostCall('consumerRateRuleSlabRequest', requestModel);
    }

    rateRuleSlabApproveRequest(requestId, otp) {
        let resourceURL = "consumerRateRuleSlabRequestApprove/" + requestId + "?otp=";
        if (otp) {
            resourceURL = resourceURL + otp;
        }
        return this.http.get(this.API_URL + resourceURL).pipe();
    }

    rateRuleSlabRejectRequest(requestId, otp) {
        let resourceURL = "consumerRateRuleSlabRequestReject/" + requestId + "?otp=";
        if (otp) {
            resourceURL = resourceURL + otp;
        }
        return this.http.get(this.API_URL + resourceURL).pipe();
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/Master/b2cRateMaster.service.ts